<section class="large-cta-section skrollable skrollable-between">
  <div class="medium-large-wrapper skrollable skrollable-after">
    <div class="medium-text-wrapper">
      <h2 class="h2 large white">Get started <span class="yellow">today</span>.</h2>
      <h3 class="h3 white">Fill Your Information Now to join us today. </h3>
      <a class="text-white" href="javascript:void(0)">
        <img src="../assets/logo.png" alt="" height="40" width="50">Med<span class="font-bold">Fest</span>
      </a>
    </div>
  </div>
</section>


<div class="container">
  <div class="card">
    <div class="card-body" *ngIf="!isLoader">
      <h5 class="card-title"></h5>
      <div [formGroup]="form" class="form-material form-horizontal">
        <div class="col-md-12">

          <div class="form-group">
            <label class="col-md-12" for="example-text"> Hospital Name
            </label>
            <div class="col-md-12 capatalize-text">
              <input type="text" alphaspace formControlName="name" name="example-text" class="form-control"
                placeholder="enter name">
              <small *ngIf="isFormSubmitted && f.name.errors && f.name.errors.required" class="text-danger">
                Name is Required.
              </small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-12" for="example-text">E-mail
            </label>
            <div class="col-md-12">
              <input type="email" formControlName="email" name="example-text" class="form-control"
                placeholder="Enter  e-mail">
              <small *ngIf="isFormSubmitted && f.email.errors && f.email.errors.required" class="text-danger">
                Email is Required.
              </small>
              <small *ngIf="isFormSubmitted && f.email.errors && f.email.errors.email" class="text-danger">
                Email must be a valid email address.
              </small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-12" for="example-text">Hotline
            </label>
            <div class="col-md-12">
              <input type="text" num formControlName="phone" name="example-text" class="form-control"
                placeholder="enter  number">
              <small *ngIf="isFormSubmitted && f.phone.errors && f.phone.errors.required" class="text-danger">
                Phone is Required.
              </small>
              <small *ngIf="isFormSubmitted && f.phone.errors && f.phone.errors?.maxlength" class="text-danger">
                Phone Number's length is exceeded
              </small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-md-12" for="example-text">Hospital Address
            </label>
            <div class="col-md-12 capatalize-text">
              <input type="text" formControlName="address" name="example-text" class="form-control"
                placeholder="enter  Address">
              <small *ngIf="isFormSubmitted && f.address.errors && f.address.errors.required" class="text-danger">
                Address is Required.
              </small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-12" for="example-text">City
            </label>
            <div class="col-md-12 capatalize-text">
              <input type="text" alphaspace formControlName="city" name="example-text" class="form-control"
                placeholder="enter  city">
              <small *ngIf="isFormSubmitted && f.city.errors && f.city.errors.required" class="text-danger">
                City is Required.
              </small>
            </div>
          </div>

        </div>
        <div class="form-group">
          <label class="col-md-12">State</label>
          <div class="col-md-12">
            <select formControlName="state" class="form-control">
              <option value="">Select State</option>
              <option *ngFor="let st of states" [value]="st">{{st}}</option>
            </select>
            <small *ngIf="isFormSubmitted && f.state.errors && f.state.errors.required" class="text-danger">
              State is Required.
            </small>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-12" for="example-text">Director Name
          </label>
          <div class="col-md-12">
            <input type="text" formControlName="directorName" name="example-text" class="form-control"
              placeholder="enter  Director Name">
            <small *ngIf="isFormSubmitted && f.directorName.errors && f.directorName.errors.required"
              class="text-danger">
              Director Name is Required.
            </small>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-12" for="example-text">Director Phone
          </label>
          <div class="col-md-12">
            <input type="text" num formControlName="directorPhone" name="example-text" class="form-control"
              placeholder="Enter Director number">
            <small *ngIf="isFormSubmitted && f.directorPhone.errors && f.directorPhone.errors.required"
              class="text-danger">
              Director Phone is Required.
            </small>
            <small *ngIf="isFormSubmitted && f.directorPhone.errors && f.directorPhone.errors?.maxlength"
              class="text-danger">
              Phone Number's length is exceeded
            </small>
          </div>
        </div>

        <!-- Description -->
        <!-- <div class="form-group">
          <label class="col-md-12">Description</label>
          <div class="col-md-12">
            <textarea formControlName="description" class="form-control" rows="3"></textarea>
            <small *ngIf="isFormSubmitted && f.description.errors && f.description.errors.required" class="text-danger">
              Description is required
            </small>
          </div>
        </div> -->

        <!-- Staff Details -->
        <div class="form-group">
          <label class="col-md-12">Staff Details</label>
          <div class="col-md-12">
            <angular-editor [placeholder]="'Enter your staff details i.e. No of patients & doctors'"
              formControlName='staffDetails' [config]="editorConfig"></angular-editor>

            <small *ngIf="isFormSubmitted && f.staffDetails.errors && f.staffDetails.errors.required"
              class="text-danger">
              Staff Detail is required
            </small>
          </div>
        </div>

        <!-- Cover Letter -->
        <div class="form-group">
          <label class="col-md-12">Cover Letter</label>
          <div class="col-md-12">
            <angular-editor [config]="editorConfig" formControlName="coverLetter"></angular-editor>
            <small *ngIf="isFormSubmitted && f.coverLetter.errors && f.coverLetter.errors.required" class="text-danger">
              Cover letter is required
            </small>
          </div>
        </div>
        <div class="text-right">
          <button type="button" [routerLink]="['/app/hospitals']"
            class="btn btn-dark waves-effect waves-light mr-2">Cancel</button>
          <button type="submit" (click)="onSave()" class="btn btn-info waves-effect waves-light m-r-10">Submit</button>
        </div>
      </div>
    </div>
    <loader *ngIf="isLoader"></loader>
  </div>
</div>